/* ============================================================
   eQiik — scripts propios (vanilla, sin librerías)
   Una función init por componente; cada una comprueba si su
   elemento existe antes de actuar.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Textos traducidos ----
     Los textos que ve el cliente NO van escritos aquí: los pone
     layout/theme.liquid en window.eqI18n (claves eq.js.* de locales), ya en
     el idioma de la página. tx('clave', { n: 3 }) sustituye [n] por 3. */
  function tx(k, vars) {
    var s = (window.eqI18n && window.eqI18n[k]) || '';
    // Shopify entrega los textos escapados para HTML (l&#39;image): aquí se
    // usan como texto plano, así que se deshace el escape.
    if (s.indexOf('&') !== -1) {
      s = s.replace(/&#39;|&#x27;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    }
    if (vars) {
      Object.keys(vars).forEach(function (n) {
        s = s.split('[' + n + ']').join(String(vars[n]));
      });
    }
    return s;
  }
  // Texto seguro dentro de un atributo HTML (comillas, <, &)
  function attr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  // Rutas de la tienda con el prefijo del idioma (/en/, /de/…): así el
  // carrito y sus avisos siguen en el idioma de la página.
  function ruta(p) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + p;
  }

  /* ---- Utilidades compartidas por la ficha de producto ----
     Precio siempre con el formato de la tienda (499,00 €) en todos los
     idiomas: así coincide con el que pinta Shopify al cargar la página y no
     cambia de aspecto al elegir modelo. */
  function money(cents) {
    var v = (cents / 100);
    // Euros enteros sin «,00» (499 €); con céntimos, dos decimales (166,33 €)
    var dec = (cents % 100 === 0) ? 0 : 2;
    return v.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + ' €';
  }
  // Variantes del inodoro (y su stock), del bloque de datos de la ficha. Se
  // leen de ahí y no de los botones de la pantalla, que NO se pintan si el
  // producto tiene un solo modelo.
  function eqVariantes() {
    var el = document.querySelector('[data-eq-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function eqVarianteActual(form) {
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    if (!idInput) return null;
    var vs = eqVariantes();
    for (var i = 0; i < vs.length; i++) {
      if (String(vs[i].id) === String(idInput.value)) return vs[i];
    }
    return null;
  }
  // Unidades que admite de verdad la variante (null = sin límite: sin
  // seguimiento de inventario o con «seguir vendiendo sin stock»).
  // Reserva: el modelo se vende sin stock («Seguir vendiendo cuando no haya stock»)
  function eqEsReserva(v) {
    return !!(v && v.available && v.managed && v.stock != null && v.stock <= 0 && v.policy === 'continue');
  }
  // Datos de la nota «Reserva: entrega en…» que viaja con el pedido (o null)
  function eqPropsReserva(form) {
    var inp = form ? form.querySelector('[data-eq-reserva-prop]') : null;
    if (!inp || inp.disabled) return null;
    var m = /^properties\[(.*)\]$/.exec(inp.name || '');
    if (!m) return null;
    var p = {}; p[m[1]] = inp.value; return p;
  }
  function eqTope(v) {
    if (!v || !v.managed || v.stock == null || v.policy === 'continue') return null;
    return v.stock;
  }
  // Pago rápido («Comprar ahora»): solo se ve si el modelo elegido se puede
  // comprar Y la casilla de instalación está desmarcada (el pago rápido solo
  // lleva un artículo). Lo llaman el selector de modelo y la casilla, así
  // nunca se contradicen.
  function eqPagoRapido(form) {
    if (!form) return;
    var pb = form.querySelector('[data-eq-pago-rapido]') || form.querySelector('.shopify-payment-button');
    if (!pb) return;
    var check = form.querySelector('[data-eq-instal-check]');
    var v = eqVarianteActual(form);
    var ok = (!v || v.available) && !(check && check.checked) && !eqEsReserva(v);
    pb.style.display = ok ? '' : 'none';
  }

  /* ---- Reveals al hacer scroll ----
     Umbral 0 y margen pequeño: al bajar rápido ya no quedan huecos en blanco
     esperando a que un bloque «entre». Lo que ya quedó por encima (salto con
     un ancla, recarga a media página) se marca visible directamente. */
  function initReveals() {
    var els = document.querySelectorAll('.eq-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eq-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          entry.target.classList.add('eq-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-countup]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-countup'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-countup'));
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 === 0) ? Math.round(val) : val.toFixed(1);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = el.getAttribute('data-countup');
        }
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ---- FAQ acordeón ----
     El estado (aria-expanded) va en el botón, que es lo que anuncia el lector
     de pantalla; aria-controls apunta a su respuesta. */
  function initFaq() {
    var btns = document.querySelectorAll('.eq-faq__q');
    if (!btns.length) return;
    var abiertas = [];
    btns.forEach(function (btn) {
      var item = btn.closest ? btn.closest('.eq-faq__item') : btn.parentNode;
      var ans = item ? item.querySelector('.eq-faq__a') : null;
      if (!ans) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        ans.style.maxHeight = open ? null : ans.scrollHeight + 'px';
        var k = abiertas.indexOf(ans);
        if (open && k !== -1) abiertas.splice(k, 1);
        if (!open && k === -1) abiertas.push(ans);
      });
    });
    // Al girar el móvil o cambiar el ancho, el texto ocupa otras líneas: se
    // recalcula el alto de las abiertas para que no se corten.
    var pendiente = false;
    window.addEventListener('resize', function () {
      if (pendiente || !abiertas.length) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        abiertas.forEach(function (a) { a.style.maxHeight = a.scrollHeight + 'px'; });
      });
    }, { passive: true });
  }

  /* ---- Galería de producto ----
     Carrusel nativo: la pista (.eq-prod__track) se desliza con el dedo o el
     trackpad y cada foto encaja sola (scroll-snap). Aquí solo se lleva la
     cuenta de la foto que se ve (contador «3 de 13», miniatura y botón de
     tipo marcados), se adelanta la carga de la anterior y la siguiente, y se
     gestiona el visor a pantalla completa con zoom (pellizco, doble toque o
     clic). Si no hay pista (imagen de muestra), no hace nada. */
  function initGallery() {
    var gallery = document.querySelector('[data-eq-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-eq-track]');
    if (!track) return;
    var todas = [].slice.call(track.querySelectorAll('[data-eq-slide]'));
    if (!todas.length) return;
    var thumbsTodas = [].slice.call(gallery.querySelectorAll('.eq-prod__thumb'));
    var strip = gallery.querySelector('.eq-prod__thumbs');
    var chipsBox = gallery.querySelector('[data-eq-chips]');
    var chips = chipsBox ? [].slice.call(chipsBox.querySelectorAll('[data-eq-chip]')) : [];
    var contador = gallery.querySelector('[data-eq-count]');
    var btnPrev = gallery.querySelector('[data-eq-prev]');
    var btnNext = gallery.querySelector('[data-eq-next]');
    var btnZoom = gallery.querySelector('[data-eq-zoom]');
    var zoomable = !!gallery.querySelector('[data-eq-zoomable]');
    var slides = [], actual = 0, objetivo = null, soltar = 0;

    function seVe(el) { return getComputedStyle(el).display !== 'none'; }
    // Miniaturas y fotos van en el mismo orden: la miniatura k es la foto k
    function thumbDe(s) { return thumbsTodas[todas.indexOf(s)] || null; }

    // Con dos modelos solo cuentan las fotos del modelo elegido (las del otro
    // están ocultas con data-eq-solo). Se recalcula al cambiar de modelo.
    function recuenta() {
      track.classList.remove('is-todas');
      slides = todas.filter(seVe);
      var todasVale = !slides.length;
      if (todasVale) { track.classList.add('is-todas'); slides = todas.slice(); } // modelo sin fotos propias
      var varias = slides.length > 1;
      [btnPrev, btnNext, contador].forEach(function (el) { if (el) el.hidden = !varias; });
      var conThumbs = !!strip && varias && !todasVale;
      if (strip) strip.hidden = !conThumbs;
      gallery.classList.toggle('eq-prod__gallery--thumbs', conThumbs);
      // Botones por tipo: solo los que tienen fotos de este modelo, y solo si
      // queda más de uno (con uno solo no sirven de nada)
      var nTipos = 0;
      chips.forEach(function (c) {
        var g = c.getAttribute('data-eq-chip');
        var hay = slides.some(function (s) { return s.getAttribute('data-grupo') === g; });
        c.hidden = !hay;
        if (hay) nTipos++;
      });
      var conChips = nTipos > 1;
      if (chipsBox) chipsBox.hidden = !conChips;
      gallery.classList.toggle('is-chips', conChips);
    }

    function indiceVisto() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }

    // inst = sin animación (p. ej. al dar la vuelta de la última a la primera)
    function centra(t, inst) {
      if (!strip || strip.hidden) return;
      var vertical = strip.scrollHeight > strip.clientHeight + 2;
      var opc = { behavior: (reduceMotion || inst) ? 'auto' : 'smooth' };
      if (vertical) opc.top = Math.max(0, t.offsetTop - (strip.clientHeight - t.offsetHeight) / 2);
      else opc.left = Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2);
      if (strip.scrollTo) strip.scrollTo(opc);
      else if (vertical) strip.scrollTop = opc.top;
      else strip.scrollLeft = opc.left;
    }
    // Degradado al final de la tira: solo mientras quedan miniaturas por ver
    function marcaFin() {
      if (!strip) return;
      var fin = strip.scrollHeight > strip.clientHeight + 2
        ? strip.scrollTop + strip.clientHeight >= strip.scrollHeight - 4
        : strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
      strip.classList.toggle('is-fin', fin);
    }

    function pinta(inst) {
      var s = slides[actual];
      if (!s) return;
      if (contador) contador.textContent = tx('contador', { actual: actual + 1, total: slides.length });
      thumbsTodas.forEach(function (t) { t.classList.remove('is-active'); t.removeAttribute('aria-current'); });
      var t = thumbDe(s);
      if (t) { t.classList.add('is-active'); t.setAttribute('aria-current', 'true'); centra(t, inst); }
      var g = s.getAttribute('data-grupo');
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-eq-chip') === g ? 'true' : 'false'); });
      // Las fotos que no están en pantalla no las lee el lector de pantalla
      slides.forEach(function (v, k) {
        if (k === actual) v.removeAttribute('aria-hidden'); else v.setAttribute('aria-hidden', 'true');
      });
      // Carga ya la foto actual (p. ej. la 1ª del otro modelo) y adelanta la
      // anterior y la siguiente (dando la vuelta: de la 1ª, ← lleva a la última)
      var n = slides.length;
      [actual, actual - 1, actual + 1].forEach(function (k) {
        var v = slides[(k + n) % n], img = v && v.querySelector('img');
        if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      });
    }

    // Mientras la pista va sola hacia una foto, el contador no «cuenta» las
    // fotos intermedias; si la persona toca, manda ella.
    function fija(i) {
      objetivo = i;
      clearTimeout(soltar);
      soltar = setTimeout(function () { objetivo = null; }, 900);
    }
    function ir(i, suave) {
      var n = slides.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      var salto = Math.abs(i - actual) > 1; // a varias fotos de distancia: directo, sin desfile
      actual = i;
      fija(i);
      var izq = slides[i].offsetLeft;
      var modo = (suave === false || reduceMotion || salto) ? 'auto' : 'smooth';
      if (track.scrollTo) track.scrollTo({ left: izq, behavior: modo });
      else track.scrollLeft = izq;
      pinta(modo === 'auto');
    }

    // Indicador de carga: cada foto tiene fondo gris y un aviso giratorio
    // hasta que llega (al saltar lejos con un botón de tipo no se ve en blanco)
    track.classList.add('con-carga');
    todas.forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      function lista() { s.classList.add('is-cargada'); }
      if (img.complete && img.naturalWidth) lista();
      else { img.addEventListener('load', lista); img.addEventListener('error', lista); }
    });
    // Cuando la página ya ha cargado, se adelanta la 1ª foto de cada tipo del
    // modelo visible (los botones por tipo saltan justo ahí)
    function precargaGrupos() {
      var vistos = {};
      slides.forEach(function (s) {
        var g = s.getAttribute('data-grupo');
        if (!g || vistos[g]) return;
        vistos[g] = true;
        var img = s.querySelector('img');
        if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      });
    }
    function enReposo(fn) {
      function va() {
        if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
        else setTimeout(fn, 300);
      }
      if (document.readyState === 'complete') va();
      else window.addEventListener('load', va);
    }

    var pendiente = false;
    track.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        var i = indiceVisto();
        if (objetivo !== null) {
          if (i !== objetivo) return;
          objetivo = null;
        }
        if (i !== actual) { actual = i; pinta(); }
      });
    }, { passive: true });
    ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) {
      track.addEventListener(ev, function () { objetivo = null; }, { passive: true });
    });

    // Al cambiar el ancho (girar el móvil…), la foto actual sigue en su sitio
    var anchoPrevio = track.clientWidth;
    window.addEventListener('resize', function () {
      if (track.clientWidth !== anchoPrevio) {
        anchoPrevio = track.clientWidth;
        var s = slides[actual];
        if (s) { fija(actual); track.scrollLeft = s.offsetLeft; }
      }
      marcaFin();
      if (lb && !lb.hidden) aplica(false);
    }, { passive: true });

    if (btnPrev) btnPrev.addEventListener('click', function () { ir(actual - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { ir(actual + 1); });
    thumbsTodas.forEach(function (t, k) {
      t.addEventListener('click', function () {
        var i = slides.indexOf(todas[k]);
        if (i !== -1) ir(i);
      });
    });
    // Botón de tipo: primera foto de ese tipo del modelo elegido
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var g = c.getAttribute('data-eq-chip');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-grupo') === g) { ir(i); return; }
        }
      });
    });

    // Teclado: ← → en cualquier parte de la galería (↑ ↓ también en las
    // miniaturas, que en ordenador van en columna); Intro sobre la foto la amplía
    gallery.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'Enter' && e.target === track && zoomable) { e.preventDefault(); lbAbre(); return; }
      var enThumb = !!(e.target.classList && e.target.classList.contains('eq-prod__thumb'));
      var paso = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!paso && enThumb) paso = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
      if (!paso || slides.length < 2) return;
      e.preventDefault();
      ir(actual + paso);
      if (enThumb) {
        var t = thumbDe(slides[actual]);
        if (t) { try { t.focus({ preventScroll: true }); } catch (er) { t.focus(); } }
      }
    });

    // Al cambiar de modelo: primera foto del modelo nuevo
    document.addEventListener('eq:modelo-change', function () {
      recuenta();
      actual = 0;
      objetivo = null;
      track.scrollLeft = 0;
      if (strip) { strip.scrollLeft = 0; strip.scrollTop = 0; }
      pinta(true);
      marcaFin();
      enReposo(precargaGrupos);
    });

    /* Visor a pantalla completa con zoom
       - Móvil: pellizcar (hasta 4×) o tocar dos veces; arrastrar para moverse.
       - Ordenador: clic para ver la foto a tamaño real (≈1,8×) y otra vez
         para volver; arrastrar para moverse; Ctrl + rueda también acerca.
       - Deslizar cambia de foto solo si no hay zoom. El zoom se reinicia al
         cambiar de foto o cerrar. */
    var lb = null, lbStage, lbImg, lbCount, lbAyuda, lbPrev, lbNext, lbI = 0, previo = null;
    var z = 1, panX = 0, ty = 0, punteros = {}, gesto = null, ultimoToque = null, tCierre = 0;
    var ZMAX = 4;
    var tactil = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    function ico(d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
    function dist(a, b) { return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y)); }
    // Punto de la pantalla respecto al centro del visor (donde está centrada la foto)
    function rel(x, y) {
      var r = lbStage.getBoundingClientRect();
      return { x: x - r.left - r.width / 2, y: y - r.top - r.height / 2 };
    }
    function aplica(anim, libre) {
      if (!lbImg) return;
      if (z < 1.02) z = 1;
      if (!libre) {
        // Con zoom, la foto no se puede arrastrar más allá de sus bordes
        var mx = Math.max(0, (lbImg.offsetWidth * z - lbStage.clientWidth) / 2);
        var my = Math.max(0, (lbImg.offsetHeight * z - lbStage.clientHeight) / 2);
        panX = Math.max(-mx, Math.min(mx, panX));
        ty = Math.max(-my, Math.min(my, ty));
      }
      lbImg.classList.toggle('is-anim', !!anim && !reduceMotion);
      lbImg.style.transform = 'translate3d(' + panX + 'px,' + ty + 'px,0) scale(' + z + ')';
      lb.classList.toggle('is-zoom', z > 1);
      // En ordenador, si la foto ya se ve a su tamaño real, el clic no amplía
      var sinZoom = !tactil && z === 1 && zoomReal() <= 1.1;
      lb.classList.toggle('sin-zoom', sinZoom);
      lbAyuda.textContent = z > 1
        ? (tactil ? tx('zoom_alejar_tactil') : tx('zoom_alejar_raton'))
        : (tactil ? tx('zoom_ampliar_tactil') : (sinZoom ? '' : tx('zoom_ampliar_raton')));
    }
    // Cambia el zoom dejando quieto, bajo el dedo o el ratón, el punto (px, py)
    function zoomA(nz, px, py, anim) {
      nz = Math.max(1, Math.min(ZMAX, nz));
      px = px || 0; py = py || 0;
      panX = px - (px - panX) * nz / z;
      ty = py - (py - ty) * nz / z;
      z = nz;
      if (z === 1) { panX = 0; ty = 0; }
      aplica(anim);
    }
    // Clic en ordenador: la foto a su tamaño real y nunca más (el archivo mide
    // 1200 px; pasarse se vería borroso). 1 = ya se ve a tamaño real: sin zoom.
    function zoomReal() {
      if (!lbImg.naturalWidth || !lbImg.offsetWidth) return 1;
      return Math.max(1, Math.min(ZMAX, lbImg.naturalWidth / lbImg.offsetWidth));
    }
    function reinicia() {
      z = 1; panX = 0; ty = 0; punteros = {}; gesto = null; ultimoToque = null;
      clearTimeout(tCierre);
      if (lb) lb.classList.remove('is-arrastre');
      aplica(false);
    }

    function lbCrea() {
      lb = document.createElement('div');
      lb.className = 'eq-lb';
      lb.hidden = true;
      lb.setAttribute('tabindex', '-1');
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', tx('visor_titulo'));
      lb.innerHTML = '<div class="eq-lb__stage"><img class="eq-lb__img" alt="" draggable="false"></div>' +
        '<button type="button" class="eq-lb__btn eq-lb__close" aria-label="' + attr(tx('cerrar')) + '">' + ico('<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>') + '</button>' +
        '<button type="button" class="eq-lb__btn eq-lb__prev" aria-label="' + attr(tx('foto_anterior')) + '">' + ico('<polyline points="15 18 9 12 15 6"/>') + '</button>' +
        '<button type="button" class="eq-lb__btn eq-lb__next" aria-label="' + attr(tx('foto_siguiente')) + '">' + ico('<polyline points="9 18 15 12 9 6"/>') + '</button>' +
        '<p class="eq-lb__pie"><span class="eq-lb__count" aria-live="polite"></span><span class="eq-lb__ayuda" aria-hidden="true"></span></p>';
      document.body.appendChild(lb);
      lbStage = lb.querySelector('.eq-lb__stage');
      lbImg = lb.querySelector('.eq-lb__img');
      lbCount = lb.querySelector('.eq-lb__count');
      lbAyuda = lb.querySelector('.eq-lb__ayuda');
      lbPrev = lb.querySelector('.eq-lb__prev');
      lbNext = lb.querySelector('.eq-lb__next');
      function llega() { lb.classList.remove('is-cargando'); aplica(false); }
      lbImg.addEventListener('load', llega);
      lbImg.addEventListener('error', llega);
      lb.querySelector('.eq-lb__close').addEventListener('click', lbCierra);
      lbPrev.addEventListener('click', function () { lbPaso(-1); });
      lbNext.addEventListener('click', function () { lbPaso(1); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); lbCierra(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); lbPaso(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); lbPaso(-1); }
        else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomA(z * 1.5, 0, 0, true); }
        else if (e.key === '-') { e.preventDefault(); zoomA(z / 1.5, 0, 0, true); }
        else if (e.key === '0') { e.preventDefault(); zoomA(1, 0, 0, true); }
        else if (e.key === 'Tab') {
          // El foco no sale del visor mientras está abierto
          var bs = [].slice.call(lb.querySelectorAll('button')).filter(function (b) { return !b.hidden; });
          var k = bs.indexOf(document.activeElement);
          e.preventDefault();
          bs[(k + (e.shiftKey ? -1 : 1) + bs.length) % bs.length].focus();
        }
      });
      // Safari antiguo: que el pellizco no acerque la página por debajo
      lb.addEventListener('gesturestart', function (e) { e.preventDefault(); });
      lbStage.addEventListener('wheel', function (e) {
        if (!e.ctrlKey) return; // pellizco del trackpad / Ctrl + rueda
        e.preventDefault();
        var p = rel(e.clientX, e.clientY);
        zoomA(z * Math.exp(-e.deltaY / 100), p.x, p.y, false);
      }, { passive: false });

      lbStage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.pointerType === 'mouse') e.preventDefault(); // sin selección ni arrastre fantasma
        clearTimeout(tCierre); // un segundo toque: era doble toque, no «cerrar»
        try { lbStage.setPointerCapture(e.pointerId); } catch (er) {}
        punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(punteros);
        if (ids.length === 1) {
          gesto = { tipo: 'uno', x0: e.clientX, y0: e.clientY, tx0: panX, ty0: ty, movido: false, sobreImg: e.target === lbImg };
        } else if (ids.length === 2) {
          var a = punteros[ids[0]], b = punteros[ids[1]];
          var m = rel((a.x + b.x) / 2, (a.y + b.y) / 2);
          gesto = { tipo: 'pellizco', d0: dist(a, b) || 1, z0: z, mx: m.x, my: m.y, tx0: panX, ty0: ty };
        }
      });
      lbStage.addEventListener('pointermove', function (e) {
        if (!punteros[e.pointerId] || !gesto) return;
        punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(punteros);
        if (gesto.tipo === 'pellizco' && ids.length >= 2) {
          var a = punteros[ids[0]], b = punteros[ids[1]];
          var m = rel((a.x + b.x) / 2, (a.y + b.y) / 2);
          var nz = Math.max(1, Math.min(ZMAX, gesto.z0 * dist(a, b) / gesto.d0));
          // El punto entre los dedos se queda bajo los dedos y se mueve con ellos
          panX = m.x - (gesto.mx - gesto.tx0) * nz / gesto.z0;
          ty = m.y - (gesto.my - gesto.ty0) * nz / gesto.z0;
          z = nz;
          aplica(false);
        } else if (gesto.tipo === 'uno') {
          var dx = e.clientX - gesto.x0, dy = e.clientY - gesto.y0;
          if (!gesto.movido && Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          gesto.movido = true;
          if (z > 1) {
            lb.classList.add('is-arrastre');
            panX = gesto.tx0 + dx; ty = gesto.ty0 + dy;
            aplica(false);
          } else if (slides.length > 1 && !gesto.trasPellizco) {
            panX = dx; ty = 0; // sin zoom, la foto sigue al dedo; al soltar cambia o vuelve
            aplica(false, true);
          }
        }
      });
      function suelta(e) {
        if (!punteros[e.pointerId]) return;
        delete punteros[e.pointerId];
        lb.classList.remove('is-arrastre');
        var quedan = Object.keys(punteros);
        if (!gesto) return;
        if (gesto.tipo === 'pellizco') {
          if (quedan.length === 1) {
            // Queda un dedo: sigue moviendo la foto (no cuenta como toque)
            var p = punteros[quedan[0]];
            gesto = { tipo: 'uno', x0: p.x, y0: p.y, tx0: panX, ty0: ty, movido: true, trasPellizco: true };
          } else if (!quedan.length) {
            gesto = null;
            aplica(true);
          }
          return;
        }
        if (quedan.length) return;
        var g = gesto;
        gesto = null;
        if (e.type === 'pointercancel') { if (z === 1) { panX = 0; ty = 0; } aplica(true); return; }
        if (g.movido) {
          if (z === 1) {
            var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
            // Tras un pellizco, soltar el último dedo nunca cambia de foto
            if (!g.trasPellizco && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && slides.length > 1) lbPaso(dx < 0 ? 1 : -1);
            else { panX = 0; ty = 0; aplica(true); }
          }
          return;
        }
        // Toque o clic sin moverse
        var c = rel(e.clientX, e.clientY);
        if (e.pointerType === 'mouse') {
          if (z > 1) zoomA(1, 0, 0, true);
          else if (g.sobreImg) { var zr = zoomReal(); if (zr > 1.1) zoomA(zr, c.x, c.y, true); }
          else lbCierra(); // clic fuera de la foto: cerrar
          return;
        }
        var ahora = Date.now();
        if (ultimoToque && ahora - ultimoToque.t < 320 &&
            Math.abs(e.clientX - ultimoToque.x) < 30 && Math.abs(e.clientY - ultimoToque.y) < 30) {
          ultimoToque = null;
          if (z > 1) zoomA(1, 0, 0, true);
          else zoomA(2.5, c.x, c.y, true);
        } else {
          ultimoToque = { t: ahora, x: e.clientX, y: e.clientY };
          // Un toque suelto fuera de la foto (sin zoom) cierra el visor, si
          // no llega un segundo toque
          if (!g.sobreImg && z === 1) tCierre = setTimeout(lbCierra, 330);
        }
      }
      lbStage.addEventListener('pointerup', suelta);
      lbStage.addEventListener('pointercancel', suelta);
    }
    function lbPinta() {
      var s = slides[lbI];
      if (!s) return;
      var n = slides.length;
      var img = s.querySelector('img');
      var alt = img ? img.alt : '';
      var url = s.getAttribute('data-full') || (img ? (img.currentSrc || img.src) : '');
      // Mientras llega la foto nueva no se ve la anterior: se oculta y sale un
      // aviso de carga (si ya estaba descargada, aparece al instante)
      if (lbImg.getAttribute('src') !== url) {
        lb.classList.add('is-cargando');
        lbImg.src = url;
        if (lbImg.complete && lbImg.naturalWidth) lb.classList.remove('is-cargando');
      }
      lbImg.alt = alt;
      reinicia();
      lbCount.textContent = tx('contador', { actual: lbI + 1, total: n });
      lb.setAttribute('aria-label', tx('visor_imagen', { actual: lbI + 1, total: n }) + (alt ? ': ' + alt : ''));
      lbPrev.hidden = lbNext.hidden = n < 2;
      // Adelanta la foto anterior y la siguiente del visor
      if (n > 1) {
        [lbI - 1, lbI + 1].forEach(function (k) {
          var v = slides[(k + n) % n], u = v && v.getAttribute('data-full');
          if (u) { var pre = new Image(); pre.src = u; }
        });
      }
    }
    function lbAbre() {
      if (!lb) lbCrea();
      lbI = actual;
      lbPinta();
      previo = document.activeElement;
      lb.hidden = false;
      document.documentElement.classList.add('eq-lb-abierto');
      aplica(false); // ya con medidas reales
      lb.querySelector('.eq-lb__close').focus();
    }
    function lbCierra() {
      if (!lb || lb.hidden) return;
      reinicia();
      lb.hidden = true;
      document.documentElement.classList.remove('eq-lb-abierto');
      if (lbI !== actual) ir(lbI, false);
      if (previo && previo.focus) { try { previo.focus({ preventScroll: true }); } catch (er) { previo.focus(); } }
    }
    function lbPaso(d) {
      var n = slides.length;
      if (n < 2) return;
      lbI = ((lbI + d) % n + n) % n;
      lbPinta();
    }

    if (btnZoom) btnZoom.addEventListener('click', lbAbre);
    // Clic en la foto: visor (deslizar con el dedo no genera clic)
    if (zoomable) {
      track.addEventListener('click', function (e) {
        var s = e.target.closest ? e.target.closest('[data-eq-slide]') : null;
        if (!s) return;
        var k = slides.indexOf(s);
        if (k !== -1 && k !== actual) { actual = k; pinta(); }
        lbAbre();
      });
    }

    if (strip) {
      strip.addEventListener('scroll', marcaFin, { passive: true });
    }

    recuenta();
    actual = indiceVisto(); // al volver atrás, el navegador puede recordar la posición
    pinta(true);
    marcaFin();
    enReposo(precargaGrupos);
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var form = document.querySelector('[data-eq-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-eq-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-eq-price]');
    var addBtn = form.querySelector('[data-eq-add]');
    var buttons = document.querySelectorAll('.eq-prod__variant');
    if (!buttons.length) return;

    // Cuota de Klarna (precio ÷ 3, redondeo a la baja, igual que muestra Klarna)
    function updateKlarna(cents) {
      var el = document.querySelector('[data-eq-klarna-cuota]');
      if (el && cents != null) el.textContent = money(Math.floor(cents / 3));
    }
    // Etiqueta de la oferta de lanzamiento: se actualiza (o se oculta) según el modelo
    function updateOferta(v) {
      var badge = document.querySelector('[data-eq-oferta]');
      if (!badge) return;
      var dto = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
      var dtoEl = badge.querySelector('[data-eq-oferta-dto]');
      if (dtoEl && dto) dtoEl.textContent = '−' + money(dto).replace(/[.,]00(?=[^0-9]*$)/, '');
      badge.style.display = dto ? '' : 'none';
    }
    function select(variantId) {
      var v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span>' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          // Estilo nuevo con tachado: «Precio anterior» para lectores de pantalla y la píldora del descuento
          var antes = priceEl.getAttribute('data-eq-antes');
          if (antes) antes = antes.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          html += '<del>' + (antes ? '<span class="visually-hidden">' + antes + ' </span>' : '') + money(v.compare_at_price) + '</del>';
          if (priceEl.hasAttribute('data-eq-dto-chip')) {
            html += '<span class="eq-prod__dto">−' + money(v.compare_at_price - v.price).replace(/[.,]00(?=[^0-9]*$)/, '') + '</span>';
          }
        }
        priceEl.innerHTML = html;
      }
      updateOferta(v);
      updateKlarna(v.price);
      eqSetVariantUrl(v.id);
      // Contenido por modelo (fotos, características, tabla, instalación…)
      if (v.modelo && document.documentElement.getAttribute('data-eq-modelo') !== v.modelo) {
        document.documentElement.setAttribute('data-eq-modelo', v.modelo);
        document.dispatchEvent(new CustomEvent('eq:modelo-change', { detail: { modelo: v.modelo } }));
        // Un vídeo que se queda oculto (es del otro modelo) no debe seguir sonando
        [].forEach.call(document.querySelectorAll('[data-eq-solo] iframe'), function (f) {
          var caja = f.closest('[data-eq-solo]');
          if (!caja || getComputedStyle(caja).display !== 'none') return;
          var marco = f.closest('[data-eq-video]');
          if (marco && marco._eqPortada) marco.replaceChild(marco._eqPortada, f);
          else if (f.src) f.src = f.src.replace('autoplay=1', 'autoplay=0');
        });
      }
      // Si hay casilla de instalación, de avisar a Klarna se encarga refrescar()
      // (que sabe si hay que sumar los 290 €): así no se le pide redibujarse
      // dos veces seguidas por el mismo cambio.
      if (!document.querySelector('[data-eq-instal-check]')) eqKlarnaWidget(v.price);
      // Pago rápido: fuera si el modelo está agotado (o la casilla marcada)
      eqPagoRapido(form);
      // La casilla de instalación recalcula su cuota al cambiar de modelo
      // (y vuelve a avisar a Klarna con el importe que incluye la instalación)
      document.dispatchEvent(new CustomEvent('eq:variant-change'));
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = (eqEsReserva(v) && addBtn.getAttribute('data-label-reserva')) || addBtn.getAttribute('data-label') || tx('anadir_carrito'); }
        else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = tx('agotado'); }
      }
      // Reserva: etiqueta, línea bajo el precio, aviso de entrega, contador y nota del pedido
      var reserva = eqEsReserva(v);
      [].forEach.call(document.querySelectorAll('[data-eq-oferta-txt], [data-eq-nota], [data-eq-instal-nota]'), function (el) {
        var t = el.getAttribute(reserva ? 'data-reserva' : 'data-normal');
        if (t) el.textContent = t;
      });
      var resEl = document.querySelector('[data-eq-reserva]');
      if (resEl) resEl.hidden = !reserva;
      var relojEl = document.querySelector('[data-eq-reloj]');
      if (relojEl) relojEl.hidden = reserva;
      var propEl = form.querySelector('[data-eq-reserva-prop]');
      if (propEl) propEl.disabled = !reserva;
      // Un aviso de stock del modelo anterior ya no vale para este
      var errEl = form.querySelector('[data-eq-instal-error]');
      if (errEl) errEl.hidden = true;
      // Escasez real: aviso de últimas unidades (singular/plural según stock),
      // bloque de agotado y tope de cantidad siguen al inventario de la variante
      var stockEl = document.querySelector('[data-eq-stock]');
      if (stockEl) {
        var pocas = v.available && v.managed && v.stock != null && v.stock > 0 && v.stock <= 2;
        stockEl.hidden = !pocas;
        var stockTxt = stockEl.querySelector('[data-eq-stock-txt]');
        if (stockTxt && pocas) {
          var txtVarias = stockEl.getAttribute('data-texto-varias') || '';
          var txtUna = stockEl.getAttribute('data-texto-una') || '';
          if (v.stock > 1 && txtVarias) stockTxt.textContent = txtVarias.replace('{stock}', v.stock);
          else if (txtUna) stockTxt.textContent = txtUna;
        }
      }
      var agotadoEl = document.querySelector('[data-eq-agotado]');
      if (agotadoEl) agotadoEl.hidden = !!v.available;
      var qtyIn = document.querySelector('[data-eq-qty-input]');
      if (qtyIn) {
        if (v.managed && v.stock > 0) {
          qtyIn.setAttribute('max', String(v.stock));
          if (parseInt(qtyIn.value, 10) > v.stock) qtyIn.value = v.stock;
        } else {
          qtyIn.removeAttribute('max');
        }
      }
      // El aviso de «1 unidad por pedido» solo aparece cuando de verdad el tope
      // es una: si no, el «+» sí funciona y el aviso sobraría.
      var qtyNota = document.querySelector('[data-eq-qty-nota]');
      if (qtyNota) qtyNota.hidden = true; // aviso «1 unidad por pedido» retirado (16/10)
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        select(btn.getAttribute('data-variant-id'));
      });
    });
    // Estado inicial del pago rápido (p. ej. si se entra con un modelo agotado)
    eqPagoRapido(form);
  }

  /* ---- Selector de cantidad ---- */
  function initQty() {
    var box = document.querySelector('[data-eq-qty]');
    if (!box) return;
    var input = box.querySelector('[data-eq-qty-input]');
    var minus = box.querySelector('[data-eq-qty-minus]');
    var plus = box.querySelector('[data-eq-qty-plus]');
    if (!input) return;
    function clamp() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      input.value = v;
    }
    // El «+» respeta el tope de existencias (atributo max, si existe)
    function tope() {
      var m = parseInt(input.getAttribute('max'), 10);
      return isNaN(m) ? Infinity : m;
    }
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = Math.min(tope(), (parseInt(input.value, 10) || 1) + 1); });
    input.addEventListener('change', function () {
      clamp();
      var m = tope();
      if (parseInt(input.value, 10) > m) input.value = m;
    });
  }

  /* ---- Widget oficial de Klarna ----
     El widget de Klarna solo lee el «?variant=» de la dirección cuando se
     carga la página. Si el cliente cambiaba de modelo o marcaba la instalación,
     se quedaba con el importe del primer modelo y enseñaba una cuota que no era
     la suya, contradiciendo a nuestra propia línea de financiación justo en la
     pantalla donde se decide. Aquí se le pasa el importe real y se le pide que
     se vuelva a dibujar. */
  function eqKlarnaWidget(cents) {
    if (cents == null || !isFinite(cents) || cents <= 0) return;
    var phs = document.querySelectorAll('klarna-placement');
    if (!phs.length) return;
    for (var i = 0; i < phs.length; i++) {
      phs[i].setAttribute('data-purchase-amount', String(Math.round(cents)));
    }
    try {
      if (window.Klarna && window.Klarna.OnsiteMessaging &&
          typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        window.Klarna.OnsiteMessaging.refresh();
      }
    } catch (e) {}
  }

  /* La dirección refleja el modelo elegido: así Klarna acierta también al
     recargar, el enlace del modelo se puede compartir y el botón «atrás» del
     navegador recuerda cuál estaba elegido. */
  function eqSetVariantUrl(id) {
    if (!id || !window.history || !window.history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', String(id));
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
  }

  /* ---- Instalación profesional opcional ----
     Aquí solo se pintan los importes y se decide qué se ve. El envío al
     carrito (con o sin la casilla) lo hace initEnvio(), un único manejador. */
  function initInstalacion() {
    var form = document.querySelector('[data-eq-product-form]');
    var check = document.querySelector('[data-eq-instal-check]');
    if (!form || !check) return;
    var instalPrice = parseInt(check.getAttribute('data-price'), 10) || 0;

    function precioVarianteActual() {
      var v = eqVarianteActual(form);
      return v ? v.price : 0;
    }
    // Con la casilla marcada, TODO lo que habla de dinero refleja inodoro +
    // instalación: nuestra cuota, el widget oficial de Klarna y el total.
    // El pago rápido (Comprar ahora) solo lleva un artículo, así que se oculta
    // para que el pedido nunca llegue sin la instalación — y se explica al
    // lado, para que al cliente no le desaparezca un botón sin motivo.
    function refrescar() {
      var base = precioVarianteActual();
      var extra = check.checked ? instalPrice : 0;
      var el = document.querySelector('[data-eq-klarna-cuota]');
      if (el) el.textContent = money(Math.floor((base + extra) / 3));
      // El widget oficial de Klarna recalcula el importe él solo a partir de la
      // variante de la dirección, así que no acepta que le sumemos los 290 € de
      // la instalación: enseñaría la cuota del inodoro suelto justo al lado de
      // la nuestra, ya sumada. Con la casilla marcada se oculta — mejor una
      // cifra correcta que dos que se contradicen. Sin marcar, vuelve y
      // coincide exactamente con la nuestra.
      var kp = document.querySelector('klarna-placement');
      var kbox = kp ? ((kp.closest && kp.closest('.eq-prod__appblock')) || kp) : null;
      if (kbox) kbox.style.display = check.checked ? 'none' : '';
      // Solo se le pide redibujarse cuando está a la vista: dentro de un
      // contenedor oculto a veces se queda en blanco al volver a mostrarlo.
      if (!check.checked) eqKlarnaWidget(base);
      var tot = document.querySelector('[data-eq-instal-total]');
      if (tot) {
        tot.textContent = tx('total_instalacion', { total: money(base + extra) });
        tot.hidden = !check.checked;
      }
      // Pago rápido: visible solo con modelo disponible Y casilla desmarcada
      eqPagoRapido(form);
      var nota = document.querySelector('[data-eq-instal-pago]');
      if (nota) nota.hidden = !check.checked;
    }
    check.addEventListener('change', refrescar);
    document.addEventListener('eq:variant-change', refrescar);

    // Al volver atrás, el navegador restaura la página tal y como estaba: la
    // casilla marcada volvía sin el total ni el aviso. Aquí se repinta.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return; // en la carga normal ya lo hace el refrescar() final
      refrescar();
    });

    // Los navegadores recuerdan la casilla marcada al recargar o al volver
    // atrás, así que hay que pintar los importes al arrancar: si no, quedaba
    // marcada pero sin total y con el botón de pago rápido otra vez visible.
    refrescar();
  }

  /* ---- Envío al carrito de la ficha (con o sin instalación) ----
     Un solo manejador para el formulario. Antes, sin la casilla marcada, el
     formulario se enviaba tal cual y dejaba meter más unidades de las que hay
     (con 1 eQiik ya en el carrito y stock 1 se llegó a eQiik x2 = 998 €).
     Ahora siempre se mira el carrito y el stock real antes de añadir. */
  function initEnvio() {
    var form = document.querySelector('[data-eq-product-form]');
    if (!form) return;
    // Navegadores muy antiguos: se deja el envío normal del formulario
    if (!window.fetch || !window.Promise) return;
    var addBtn = form.querySelector('[data-eq-add]');
    var errEl = form.querySelector('[data-eq-instal-error]');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'eq-prod__error';
      errEl.setAttribute('role', 'alert');
      errEl.setAttribute('data-eq-instal-error', '');
      errEl.hidden = true;
      if (addBtn && addBtn.parentNode) addBtn.parentNode.insertBefore(errEl, addBtn.nextSibling);
      else form.appendChild(errEl);
    }

    var enviando = false;
    function restaurarBoton() {
      enviando = false;
      if (addBtn && addBtn.getAttribute('data-eq-enviando')) {
        addBtn.removeAttribute('data-eq-enviando');
        // Si el modelo elegido está agotado, el botón sigue bloqueado
        var v = eqVarianteActual(form);
        if (v && !v.available) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = tx('agotado');
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = (eqEsReserva(v) && addBtn.getAttribute('data-label-reserva')) || addBtn.getAttribute('data-label') || tx('anadir_carrito');
        }
      }
    }
    // Aviso junto al botón, con enlace al carrito cuando ayuda
    function aviso(msg, conCarrito, esInfo) {
      errEl.textContent = msg;
      errEl.classList.toggle("is-info", !!esInfo);
      if (conCarrito) {
        errEl.appendChild(document.createTextNode(' '));
        var a = document.createElement('a');
        a.href = ruta('cart');
        a.textContent = tx('ver_carrito');
        errEl.appendChild(a);
      }
      errEl.hidden = false;
    }
    function avisoError(msg) {
      var tel = errEl.getAttribute('data-tel');
      aviso(msg || (tel ? tx('error_anadir_tel', { tel: tel }) : tx('error_anadir')));
    }
    // Al volver atrás el botón se quedaba en «Añadiendo…» y sin responder
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) restaurarBoton();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando) return; // en un móvil lento es normal tocar dos veces

      var check = form.querySelector('[data-eq-instal-check]');
      var conInstal = !!(check && check.checked);
      var instalId = check ? parseInt(check.getAttribute('data-variant'), 10) : NaN;
      var idInput = form.querySelector('input[name="id"]');
      var qtyIn = form.querySelector('[data-eq-qty-input]');
      var qty = qtyIn ? (parseInt(qtyIn.value, 10) || 1) : 1;
      if (qty < 1) qty = 1;
      var varId = idInput ? parseInt(idInput.value, 10) : NaN;
      var propsRes = eqPropsReserva(form);
      errEl.hidden = true;
      if (isNaN(varId)) { avisoError(null); return; }

      enviando = true;
      var yaAnadido = false;
      var parcial = '';
      if (addBtn) {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.setAttribute('data-eq-enviando', '1');
        addBtn.textContent = tx('anadiendo');
      }
      // Shopify explica el motivo mucho mejor que un mensaje genérico
      // (p. ej. «Tu carrito ya tiene la cantidad máxima de este artículo»).
      function fallo(r) {
        return r.json().then(function (d) {
          throw new Error((d && (d.description || d.message)) || '');
        }, function () { throw new Error(''); });
      }

      fetch(ruta('cart.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(''); return r.json(); })
        .then(function (cart) {
          var vars = eqVariantes();
          var ids = [], tope = null, j;
          for (j = 0; j < vars.length; j++) {
            ids.push(vars[j].id);
            if (String(vars[j].id) === String(varId)) tope = eqTope(vars[j]);
          }
          var yaEste = 0, yaInstal = 0, yaInodoros = 0;
          var items = cart.items || [];
          for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id === varId) yaEste += items[i].quantity;
            if (items[i].variant_id === instalId) yaInstal += items[i].quantity;
            if (ids.indexOf(items[i].variant_id) !== -1) yaInodoros += items[i].quantity;
          }

          // Cuántas unidades caben de verdad: si el modelo ya está en el carrito
          // y no queda más stock, pedirlo otra vez hacía que Shopify rechazara
          // la operación entera y el cliente no podía añadir la instalación de
          // ninguna manera. Con la cuenta hecha sobre el stock real, esto sigue
          // siendo correcto el día que haya dos o más unidades por modelo.
          var inodorosNuevos = (tope == null) ? qty : Math.max(0, Math.min(qty, tope - yaEste));
          // El inodoro lleva la nota de reserva si toca (se ve en carrito y pedido)
          function eqLinea(id, n) {
            var l = { id: id, quantity: n };
            if (propsRes) l.properties = propsRes;
            return l;
          }
          var pedir = [], objetivo = 0, diferencia = 0;
          // Se pidieron más de las que quedan: se añaden las que caben y se
          // avisa en vez de llevarle al carrito como si nada
          if (inodorosNuevos > 0 && inodorosNuevos < qty) {
            parcial = inodorosNuevos === 1
              ? tx('parcial_una')
              : tx('parcial_varias', { n: inodorosNuevos });
          }
          function avisoStock() {
            var a = new Error(yaEste > 0
              ? (tope > 1
                  ? tx('stock_todas_en_carrito')
                  : tx('stock_una_en_carrito'))
              : tx('sin_stock'));
            a.eqStock = true;
            a.eqCarrito = yaEste > 0;
            return a;
          }

          if (!conInstal) {
            // Sin instalación: solo el inodoro, y nunca más unidades que stock.
            // Si ya no cabe ninguna, no se añade nada y se explica por qué.
            if (inodorosNuevos <= 0) throw avisoStock();
            pedir.push(eqLinea(varId, inodorosNuevos));
          } else {
            // Con casilla pero sin stock y sin este modelo en el carrito: no
            // hay nada que instalar; se explica en vez de ir al carrito en blanco
            if (inodorosNuevos <= 0 && yaEste === 0) throw avisoStock();
            var inodorosFinal = yaInodoros + inodorosNuevos;
            // Dos reglas que se cumplen siempre:
            //  1) marcar la casilla pide instalación para las unidades de ahora
            //     (nunca para un inodoro que el cliente añadió sin ella);
            //  2) en el carrito nunca puede haber más instalaciones que inodoros
            //     — así se corrige sola una instalación que se quedara suelta al
            //     borrar su inodoro, que si no se cobraba dos veces.
            // Si no entra ninguna unidad nueva (el modelo ya está y no queda
            // stock), basta con que haya tantas instalaciones como unidades de
            // ESTE modelo: sumar una más cobraba una instalación de más cuando
            // el carrito tenía otro modelo añadido a propósito sin ella.
            objetivo = inodorosNuevos > 0 ? yaInstal + inodorosNuevos : Math.max(yaInstal, yaEste);
            if (ids.length && objetivo > inodorosFinal) objetivo = inodorosFinal;
            diferencia = objetivo - yaInstal;
            // El carrito no guarda a qué inodoro pertenece cada instalación.
            // Si este modelo ya está, no entra ninguno nuevo, no cambia nada y
            // hay inodoros sin instalación, no se puede saber si el cliente
            // quiere una más (p. ej. eQiik con instalación + Pro sin ella, y
            // ahora marca la casilla en el Pro) o si ya la tiene (eQiik sin
            // instalación + Pro con ella). En vez de adivinar —cobrar de más o
            // quedarse corto— se le avisa y se le deja decidir en el carrito.
            if (inodorosNuevos === 0 && diferencia === 0 && yaInstal < yaInodoros) {
              var dudoso = new Error(tx('instal_dudoso'));
              dudoso.eqStock = true;
              dudoso.eqCarrito = true;
              throw dudoso;
            }
            // Se añade la instalación de este modelo, pero siguen quedando
            // inodoros sin ella: se avisa en vez de ir al carrito en silencio.
            if (inodorosNuevos === 0 && diferencia > 0 && objetivo < yaInodoros) {
              parcial = tx('instal_parcial');
            }
            if (inodorosNuevos > 0) pedir.push(eqLinea(varId, inodorosNuevos));
            if (diferencia > 0) pedir.push({ id: instalId, quantity: diferencia });
          }

          var paso = pedir.length
            ? fetch(ruta('cart/add.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: pedir })
              }).then(function (r) { if (!r.ok) return fallo(r); yaAnadido = true; })
            : Promise.resolve();

          if (diferencia < 0) {
            // Sobran instalaciones (carrito heredado o inodoro borrado): se baja
            // la cantidad a la que corresponde en vez de dejarla mal para siempre.
            paso = paso.then(function () {
              var updates = {};
              updates[instalId] = objetivo;
              return fetch(ruta('cart/update.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              }).then(function (r) { if (!r.ok) return fallo(r); });
            });
          }
          return paso;
        })
        .then(function () {
          if (parcial) {
            // Ya está en el carrito; se queda aquí para leer el aviso
            restaurarBoton();
            aviso(parcial, true, true);
            return;
          }
          window.location.href = ruta('cart');
        })
        .catch(function (err) {
          // Nunca se compra a medias ni «a ciegas»: si algo falla (también sin
          // conexión) no se envía el formulario normal con otra cantidad; se
          // avisa y no se añade nada.
          restaurarBoton();
          if (err && err.eqStock) {
            aviso(err.message, err.eqCarrito);
          } else if (yaAnadido) {
            // Caso raro: el artículo sí entró y lo que falló fue el ajuste de
            // la instalación. Decirle «no hemos podido añadirlo» sería mentira.
            aviso(tx('instal_revisar'), true);
          } else {
            avisoError(err && err.message ? err.message : null);
          }
        });
    });
  }

  /* ---- Barra de compra fija (ficha) ----
     Cuando el botón de compra sale de la pantalla por arriba, aparece abajo
     una barra con el modelo y el precio. Su botón NO compra: lleva de vuelta
     al formulario y enfoca el botón, para no saltarse la cantidad ni la
     casilla de instalación. */
  function initSticky() {
    var barra = document.querySelector('[data-eq-sticky]');
    var form = document.querySelector('[data-eq-product-form]');
    if (!barra || !form || !('IntersectionObserver' in window)) return;
    var addBtn = form.querySelector('[data-eq-add]');
    if (!addBtn) return;
    var nombreEl = barra.querySelector('[data-eq-sticky-nombre]');
    var precioEl = barra.querySelector('[data-eq-sticky-precio]');
    var btn = barra.querySelector('[data-eq-sticky-btn]');
    var unica = barra.hasAttribute('data-unica');

    function pinta() {
      var v = eqVarianteActual(form);
      if (!v) return;
      if (nombreEl && !unica) nombreEl.textContent = v.title;
      // Con la casilla marcada, el mismo total que se ve junto al botón
      var check = form.querySelector('[data-eq-instal-check]');
      var extra = (check && check.checked) ? (parseInt(check.getAttribute('data-price'), 10) || 0) : 0;
      if (precioEl) {
        precioEl.textContent = money(v.price + extra);
        if (extra) {
          var nota = document.createElement('small');
          nota.className = 'eq-sticky__extra';
          nota.textContent = ' ' + tx('con_instalacion');
          precioEl.appendChild(nota);
        }
      }
      if (btn) {
        if (v.available) {
          btn.removeAttribute('disabled');
          btn.textContent = eqEsReserva(v) ? tx('ir_reservar') : tx('ir_comprar');
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = tx('agotado');
        }
      }
    }
    document.addEventListener('eq:variant-change', pinta);
    var checkI = form.querySelector('[data-eq-instal-check]');
    if (checkI) checkI.addEventListener('change', pinta);
    window.addEventListener('pageshow', function (e) { if (e.persisted) pinta(); });
    pinta();

    var activa = false;
    function pon(on) {
      if (on === activa) return;
      activa = on;
      barra.classList.toggle('is-visible', on);
      document.body.classList.toggle('eq-con-sticky', on);
    }
    var obs = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      pon(!en.isIntersecting && en.boundingClientRect.top < 0);
    });
    obs.observe(addBtn);

    if (btn) btn.addEventListener('click', function () {
      var destino = document.querySelector('.eq-prod__optitle') ||
        document.querySelector('.eq-prod__variants') || form;
      var cab = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
      var y = destino.getBoundingClientRect().top + window.pageYOffset - cab - 16;
      window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
      try { addBtn.focus({ preventScroll: true }); } catch (e) { addBtn.focus(); }
    });
  }

  /* ---- Barra de progreso de lectura (artículos del blog) ---- */
  function initProgreso() {
    var art = document.querySelector('.article-template__content');
    if (!art) return;
    var barra = document.createElement('div');
    barra.className = 'eq-progreso';
    barra.setAttribute('aria-hidden', 'true');
    var relleno = document.createElement('span');
    barra.appendChild(relleno);
    document.body.appendChild(barra);
    var pendiente = false;
    function calcula() {
      pendiente = false;
      var r = art.getBoundingClientRect();
      var recorrido = r.height - window.innerHeight;
      var p = recorrido > 0 ? -r.top / recorrido : (r.bottom <= window.innerHeight ? 1 : 0);
      p = Math.max(0, Math.min(1, p));
      relleno.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    function pide() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(calcula);
    }
    window.addEventListener('scroll', pide, { passive: true });
    window.addEventListener('resize', pide, { passive: true });
    calcula();
  }

  /* ---- DNI o NIF del carrito ----
     Se guarda solo mientras se escribe, igual que la nota del carrito. Si no,
     el dato solo llegaba al pulsar «Pagar pedido»: quien usara un pago rápido
     (PayPal, Shop Pay) perdía lo que había escrito sin enterarse.
     Además avisa si la letra no cuadra con el número, sin bloquear la compra. */
  function initDni() {
    var campo = document.querySelector('[data-eq-dni]');

    if (!campo) {
      // Sin campo en la página del carrito = carrito vacío. El dato personal no
      // debe quedarse pegado al navegador: si sobró de una compra anterior, se
      // borra para que no acabe en un pedido que no es el suyo.
      if (document.querySelector('[data-eq-dni-limpiar]')) {
        fetch(ruta('cart.js'), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) {
            if (c && c.item_count === 0 && c.attributes && c.attributes['DNI o NIF']) {
              return fetch(ruta('cart/update.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { 'DNI o NIF': '' } })
              });
            }
          })
          .catch(function () {});
      }
      return;
    }

    var aviso = document.querySelector('[data-eq-dni-aviso]');
    var reloj = null;

    function limpio(v) { return String(v || '').toUpperCase().replace(/[^0-9A-Z]/g, ''); }

    // Letra de control del DNI y del NIE. Un NIF de empresa (letra delante) no
    // sigue esta regla, así que en ese caso no se opina.
    var LETRAS = 'TRWAGMYFPDXBNJZSQVHLCKE';
    function pareceMal(v) {
      var m = v.match(/^([XYZ]?)(\d{7,8})([A-Z])$/);
      if (!m) return false; // no parece un DNI/NIE: no decimos nada
      var num = m[2];
      if (m[1]) num = String('XYZ'.indexOf(m[1])) + num;
      return LETRAS.charAt(parseInt(num, 10) % 23) !== m[3];
    }
    function revisar() {
      if (!aviso) return;
      var v = limpio(campo.value);
      if (v !== '' && pareceMal(v)) {
        aviso.textContent = tx('dni_letra');
        aviso.hidden = false;
      } else {
        aviso.hidden = true;
      }
    }
    function guardar() {
      fetch(ruta('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'DNI o NIF': limpio(campo.value) } })
      }).catch(function () {});
    }
    campo.addEventListener('input', function () {
      revisar();
      clearTimeout(reloj);
      reloj = setTimeout(guardar, 700);
    });
    campo.addEventListener('blur', function () {
      clearTimeout(reloj);
      campo.value = limpio(campo.value); // se ordena al salir, no mientras escribe
      revisar();
      guardar();
    });
    revisar();
  }

  // Rediseño (fase 1): galería deslizable de la sección eq-tira.
  // Delegación en document: sirve también para secciones añadidas o
  // recargadas en el editor de Shopify sin volver a arrancar nada.
  function initTira() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function estado(t) {
      var caja = t.closest('[data-eqd-tira-caja]');
      if (!caja) return;
      var max = t.scrollWidth - t.clientWidth;
      var ctrl = caja.querySelector('[data-eqd-tira-ctrl]');
      if (ctrl) ctrl.hidden = max <= 2;
      var ant = caja.querySelector('[data-eqd-tira-ant]');
      var sig = caja.querySelector('[data-eqd-tira-sig]');
      var x = Math.abs(t.scrollLeft);
      if (ant) ant.setAttribute('aria-disabled', x <= 2 ? 'true' : 'false');
      if (sig) sig.setAttribute('aria-disabled', x >= max - 2 ? 'true' : 'false');
    }
    function todas() { [].forEach.call(document.querySelectorAll('[data-eqd-tira]'), estado); }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-eqd-tira-ant], [data-eqd-tira-sig]') : null;
      if (!b) return;
      var caja = b.closest('[data-eqd-tira-caja]');
      var t = caja && caja.querySelector('[data-eqd-tira]');
      if (!t) return;
      var d = b.hasAttribute('data-eqd-tira-ant') ? -1 : 1;
      t.scrollBy({ left: d * t.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-eqd-tira]')) return;
      if (t.__eqdPend) return;
      t.__eqdPend = window.requestAnimationFrame(function () { t.__eqdPend = null; estado(t); });
    }, true);
    // Al cambiar de modelo en la ficha, una galería oculta puede aparecer o cambiar de ancho
    document.addEventListener('eq:modelo-change', function () { window.requestAnimationFrame(todas); });
    window.addEventListener('resize', todas);
    window.addEventListener('load', todas);
    document.addEventListener('shopify:section:load', todas);
    // Editor de Shopify: al elegir una foto en el panel, la tira se desplaza hasta ella
    document.addEventListener('shopify:block:select', function (e) {
      var f = e.target;
      var t = f && f.closest ? f.closest('[data-eqd-tira]') : null;
      if (t) t.scrollTo({ left: f.offsetLeft - t.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    });
    todas();
  }

  // Rediseño (fase 2): botones «Elegir versión» / «Ver el Pro» de las secciones
  // nuevas. Si en la página está la zona de compra, eligen esa versión ahí y
  // suben hasta ella sin recargar; si no, el enlace normal (?variant=…) funciona.
  function initElige() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-eqd-elige]') : null;
      if (!a) return;
      var id = a.getAttribute('data-eqd-elige');
      var btn = id && document.querySelector('.eq-prod__variant[data-variant-id="' + id + '"]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-pressed') !== 'true') btn.click();
      var zona = document.getElementById('eq-comprar');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (zona) zona.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      try { btn.focus({ preventScroll: true }); } catch (er) { btn.focus(); }
    });
  }

  function boot() {
    if (window.__eqBooted) return; // se carga una sola vez desde theme.liquid; init solo una vez
    window.__eqBooted = true;
    // Cada componente arranca por separado: si uno falla (p. ej. un
    // navegador raro), los demás —y sobre todo la compra— siguen funcionando.
    [initReveals, initCountUp, initFaq, initGallery, initVariants, initQty,
     initInstalacion, initEnvio, initSticky, initProgreso, initDni, initTira, initElige].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.error('eQiik', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
